<h4>DOS Order Nr. {{order.documentOrderNumber}}</h4>
<div class="mt-3 mb-3">
  <div class="row">
    <div class="col-md-4">
      <div class="card card-preview"><span><i class="fas fa-times"></i> {{i18n.get('global_no_preview_label')}}</span>
      </div>
    </div>
    <div class="col-md-4">
      <dl>
        <dt>{{i18n.get('orders_created_on_label', 'orders')}}</dt>
        <dd>{{getCreatedDate()}} by <u>{{this.order.fullName}}</u></dd>
        <dt>Email</dt>
        <dd>{{this.order.email}}</dd>
        <dt>Machine name</dt>
        <dd>{{this.order.machineName}}</dd>
        <dt>Serial Nr.</dt>
        <dd>{{this.order.serialNumber}}</dd>
        <dt>SAP Nr.</dt>
        <dd>{{this.order.sapNumber}}</dd>
      </dl>
    </div>
    <div class="col-md-4">
      <dl>
        <dt>Delivery date</dt>
        <dd>{{getDeliveryDate()}}</dd>
      </dl>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <dl>
        <dt>{{i18n.get('orders_order_remark_label', 'orders')}}</dt>
        <dd>{{this.order.remark || i18n.get('global_no_comment_label')}}</dd>
      </dl>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <h4>Order details</h4>
      <h5>{{this.order.machineName}}</h5>
      <hr>
      <div *ngFor="let item of decodedOrderData.orderdata | keyvalue">
        <!--
        <p>db id: {{item.value._dbid}}</p>
        <p>Active: {{item.value._active}}</p>
        <p>Document set thumbnail: {{item.value._documentsetthumbnail}}</p>
        -->
        <div *ngFor="let doc of item.value._machinelanguages">
          <div *ngIf="doc._quantity > 0">
            <h6>{{item.value._documentsetname}}</h6>
            <hr>
            <p>Language: {{doc._languageiso2}} ({{doc._languagename}})</p>
            <p>Quantity: {{doc._quantity}}</p>
            <hr>
            <!--
            <p>Language id: {{doc._languageid}}</p>
            <p>Document folder id: {{doc._documentfolderid}}</p>
            <p>Document set id: {{doc._documentsetid}}</p>
            <p>Machine id: {{doc._machineid}}</p>
            <p>Machine language id: {{doc._machinelanguageid}}</p>
            <p>Document folder: {{doc._documentfolder._documentfoldername}}</p>
            -->
            <div *ngFor="let folder of doc._documentfolder._folders; let i = index" [attr.data-index]="i">
              <div *ngFor="let documentItem of folder._documentitems">
                <div *ngIf="documentItem._doctype === 'index-document'">
                  <div class="bg-info row pt-3 p-2 mt-2 no-gutters">
                    <div class="col-md-4"><strong>{{documentItem._docname}}</strong></div>
                    <div class="col-md-8">{{documentItem._filename}}</div>
                  </div>
                </div>
                <div *ngIf="documentItem._doctype === 'file-document'">
                  <div class="bg-light row p-2 no-gutters">
                    <div class="col-md-4">{{documentItem._docnumber}}</div>
                    <div class="col-md-8">{{documentItem._docname}}<br/>{{documentItem._filename}}</div>
                  </div>
                </div>
                <div *ngIf="documentItem._doctype === 'select-document'">
                  <div class="bg-light row p-2 no-gutters">
                    <ng-container *ngFor="let selectedDocument of documentItem._selecteddocuments">
                      <div class="col-md-4">[SELECT] {{selectedDocument._docnumber}}</div>
                      <div class="col-md-8">{{selectedDocument._docname}}<br/>{{selectedDocument._filename}}</div>
                    </ng-container>
                  </div>
                </div>
                <div *ngIf="documentItem._doctype === 'file-document-transport'">
                  <div class="bg-warning row pt-3 p-2 mt-2 no-gutters">
                    <div class="col-md-4"><strong>{{documentItem._docnumber}}</strong></div>
                    <div class="col-md-8">{{documentItem._docname}}<br/>{{documentItem._filename}}</div>
                  </div>
                </div>
                <hr *ngIf="documentItem._doctype === 'tab'" class="p-0 m-0 my-3 bg-dark border-0">
                <hr *ngIf="documentItem._doctype === 'red-separator'" class="bg-danger p-0 m-0">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--<pre><code>{{ decodedOrderData | json }}</code></pre>-->
